import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {Container, Header, Tab, Content} from './styles';
import {IoAddCircle} from 'react-icons/io5';

export interface TabProps {
  label: string;
  content: React.ReactNode;
  hidden?: boolean;
  tab?: string;
  createUrl?: string;
  onCreate?: () => void;
}

interface Props {
  tabs: TabProps[];
  activeTab?: string;
  setActiveTab?: (tab?: string) => void;
}

const Tabs: React.FC<Props> = ({tabs, activeTab, setActiveTab}) => {
  const {pathname} = useLocation();
  const navigate = useNavigate();

  const getIndexUrl = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, navigation, module, id] = pathname.split('/');

    return `/${navigation}/${module}/${id}`;
  };

  return (
    <Container>
      <Header>
        {tabs
          .filter(({hidden = false}) => !hidden)
          .map(({label, tab, createUrl, onCreate}) => (
            <Tab
              key={label}
              active={tab === activeTab}
              onClick={() =>
                setActiveTab
                  ? setActiveTab(tab)
                  : navigate(`${getIndexUrl()}/${tab ?? ''}`)
              }>
              <label>{label}</label>
              {tab === activeTab && (createUrl || onCreate) && (
                <IoAddCircle
                  size={20}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (createUrl) navigate(createUrl);
                    if (onCreate) onCreate();
                  }}
                />
              )}
            </Tab>
          ))}
      </Header>
      <Content>
        {
          tabs
            .filter(({hidden = false}) => !hidden)
            .find(({tab}) => tab === activeTab)?.content
        }
      </Content>
    </Container>
  );
};

export default Tabs;
